import React, { createContext, useState } from "react";
import { CopySettingsDialog } from "components/dialogs/CopySettingsDialog";

export const CopyUserSettingsContext = createContext({
	sourceUserId: null,
	setSourceUserId: () => {},
	selectedKeys: [],
	setSelectedKeys: () => {},
	isModalOpen: false,
	setIsModalOpen: () => {},
	tempSourceId: null,
	setTempSourceId: () => {},
});

export const CopyUserSettingsProvider = ({ children }) => {
	const [sourceUserId, setSourceUserId] = useState(null);
	const [tempSourceId, setTempSourceId] = useState(null);
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<CopyUserSettingsContext.Provider
			value={{
				sourceUserId,
				setSourceUserId,
				tempSourceId,
				setTempSourceId,
				selectedKeys,
				setSelectedKeys,
				isModalOpen,
				setIsModalOpen,
			}}
		>
			<CopySettingsDialog />
			{children}
		</CopyUserSettingsContext.Provider>
	);
};
